import React from "react";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";
import NotFound from "components/NotFound";
import List from "components/Order/List";
import "./Order.less";

const mapStateToProps = state => ({
    ...state.order,
});

const mapDispatchToProps = dispatch => ({});

class Order extends React.Component {
    render() {
        const { match } = this.props;
        const basepath = match.path === "/" ? "" : match.path;

        return (
            <Switch>
                <Route exact path={`${basepath}/history`} component={List} />
                <Route exact path={`${basepath}/list`} component={List} />
                <Route exact component={NotFound} />
            </Switch>
        );
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Order);
